export default "__VITE_ASSET__CYn1ackI__"